/**
 * MA-THEME-PRESET-UX-ENHANCEMENT-079: Diagnostic Funnel Preview
 *
 * Amplified to make theme differences obvious at small preview scale:
 * - Thick header border (border_strong 2px) — signature recognition
 * - Visible surface_subtle strip
 * - Bot bubbles with amplified border_subtle borders
 * - Option buttons with border_strong — amplifies border visibility
 * - Text_secondary timestamp elements
 */

export function BrandFunnelPreview({ theme }) {
  if (!theme?.tokens) return null;
  const t = theme.tokens;

  return (
    <div
      data-testid="brand-funnel-preview"
      style={{
        backgroundColor: t.surface_base,
        borderRadius: 12,
        overflow: 'hidden',
        width: '100%',
        border: `1.5px solid ${t.border_subtle}`,
      }}
    >
      {/* Header — thick border_strong bottom for signature recognition */}
      <div style={{
        backgroundColor: t.surface_subtle,
        padding: '9px 12px',
        borderBottom: `2px solid ${t.border_strong}`,
        display: 'flex', alignItems: 'center', gap: 7,
      }}>
        <div style={{ width: 20, height: 20, borderRadius: '50%', backgroundColor: t.primary }} />
        <div>
          <div style={{ width: 55, height: 6, backgroundColor: t.text_primary, borderRadius: 3, opacity: 0.75 }} />
          <div style={{ width: 35, height: 3, backgroundColor: t.text_secondary, borderRadius: 2, marginTop: 3 }} />
        </div>
      </div>

      {/* Surface_subtle diagnostic strip */}
      <div style={{ height: 3, backgroundColor: t.surface_subtle }} />

      {/* Chat area */}
      <div style={{ padding: '10px 12px', display: 'flex', flexDirection: 'column', gap: 5 }}>
        {/* Bot message — amplified border */}
        <div style={{
          backgroundColor: t.surface_elevated,
          border: `1.5px solid ${t.border_subtle}`,
          borderRadius: '9px 9px 9px 2px',
          padding: '6px 9px', maxWidth: '82%',
        }}>
          <div style={{ width: '100%', height: 5, backgroundColor: t.text_primary, borderRadius: 2, opacity: 0.65 }} />
          <div style={{ width: '50%', height: 5, backgroundColor: t.text_secondary, borderRadius: 2, marginTop: 4 }} />
        </div>

        {/* User message — right-aligned, tail on bottom-right, text right-aligned */}
        <div style={{
          backgroundColor: t.primary,
          borderRadius: '9px 9px 2px 9px',
          padding: '6px 9px', width: '70%', alignSelf: 'flex-end',
          display: 'flex', flexDirection: 'column', alignItems: 'flex-end',
        }}>
          <div style={{ width: '100%', height: 5, backgroundColor: t.primary_foreground, borderRadius: 2, opacity: 0.85 }} />
          <div style={{ width: '55%', height: 5, backgroundColor: t.primary_foreground, borderRadius: 2, opacity: 0.6, marginTop: 4 }} />
        </div>

        {/* Bot message 2 */}
        <div style={{
          backgroundColor: t.surface_elevated,
          border: `1.5px solid ${t.border_subtle}`,
          borderRadius: '9px 9px 9px 2px',
          padding: '6px 9px', maxWidth: '82%',
        }}>
          <div style={{ width: '70%', height: 5, backgroundColor: t.text_primary, borderRadius: 2, opacity: 0.6 }} />
        </div>

        {/* User reply options — right-aligned text inside bubbles */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 3, alignSelf: 'flex-end', width: '80%' }}>
          {[1, 2].map((i) => (
            <div key={i} style={{
              backgroundColor: t.primary,
              borderRadius: '9px 9px 2px 9px',
              padding: '6px 9px',
              display: 'flex', justifyContent: 'flex-end',
            }}>
              <div style={{ width: `${60 + i * 12}%`, height: 5, backgroundColor: t.primary_foreground, borderRadius: 2, opacity: 0.75 }} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
